/* eslint-disable */
import * as types from 'constants/bitacoraNotificacionActionTypes';
import {
  fetchRegReporteBitacoraNotificacion,
  fetchExcelReporteBitacoraNotificacion
} from 'services/bitacoraNotificacion.service';
import { showAlert } from './alert.actions';
import { bitacoraNotificacionDTO } from 'adapters/adapterBitacoraNotificacionData';

export const obtenRegistrosBitacoraNotificacion = (mainFilters, pageSize, page) => async (dispatch) => {
  try {
    dispatch({ type: types.REG_BITACORA_NOTIF_LOADING });

    const params = {
      idProcesoElectoral: mainFilters && mainFilters.idProcesoElectoral !== undefined && mainFilters.idProcesoElectoral !== null && mainFilters.idProcesoElectoral !== '' ? mainFilters.idProcesoElectoral : null,
      idAmbito: mainFilters && mainFilters.idAmbito !== undefined && mainFilters.idAmbito !== null && mainFilters.idAmbito !== '' ? mainFilters.idAmbito : null,
      fechaInicio: mainFilters && mainFilters.fechaInicio !== undefined && mainFilters.fechaInicio !== null && mainFilters.fechaInicio !== '' ? mainFilters.fechaInicio : null,
      fechaFinal: mainFilters && mainFilters.fechaFinal !== undefined && mainFilters.fechaFinal !== null && mainFilters.fechaFinal !== '' ? mainFilters.fechaFinal : null,
      cantidad: pageSize,
      pagina: page
    };

    const { data }  = await fetchRegReporteBitacoraNotificacion(params);
    const payload = data?.dtoBitacoraNotificacion?.bitacoraNotificacionesList.map(bitacoraNotificacionDTO);

    dispatch({ type: types.REG_BITACORA_NOTIF_SUCCESS, payload});
    return { success: true, totalNotificaciones: data?.dtoBitacoraNotificacion?.totalBitacoraNotificacion, totalNotificacionesPagina: payload.length };
  } catch (error) {
    dispatch({ type: types.REG_BITACORA_NOTIF_FAILURE });
    dispatch(showAlert('Error al consultar la bitácora de notificaciones', 'error'));
    return { success: false };
  }
};


export const downloadExcelBitacoraNotificacion = (mainFilters) => async (dispatch) => {
  try {

    dispatch({ type: types.EXCEL_BITACORA_NOTIF_LOADING });

    const params = {
      idProcesoElectoral: mainFilters && mainFilters.idProcesoElectoral !== undefined && mainFilters.idProcesoElectoral !== null && mainFilters.idProcesoElectoral !== '' ? mainFilters.idProcesoElectoral : null,
      idAmbito: mainFilters && mainFilters.idAmbito !== undefined && mainFilters.idAmbito !== null && mainFilters.idAmbito !== '' ? mainFilters.idAmbito : null,
      fechaInicio: mainFilters && mainFilters.fechaInicio !== undefined && mainFilters.fechaInicio !== null && mainFilters.fechaInicio !== '' ? mainFilters.fechaInicio : null,
      fechaFinal: mainFilters && mainFilters.fechaFinal !== undefined && mainFilters.fechaFinal !== null && mainFilters.fechaFinal !== '' ? mainFilters.fechaFinal : null
    };

    const response = await fetchExcelReporteBitacoraNotificacion(params);

    dispatch({ type: types.EXCEL_BITACORA_NOTIF_SUCCESS });

    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.EXCEL_BITACORA_NOTIF_FAILURE });
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};